import type { AgentPromptPage, AgentPromptPresetList } from '../config';

import { patientPagePresets } from './patient';
import {
  reportBitewingsPagePresets,
  reportCbctPagePresets,
  reportEndoPagePresets,
  reportImplantPagePresets,
  reportIoxrayPagePresets,
  reportMolarPagePresets,
  reportPanoPagePresets,
  reportPagePresets,
  reportSegmentationPagePresets,
} from './reports';
import {
  consultationPagePresets,
  documentPagePresets,
  encounterPagePresets,
  photosPagePresets,
  templatesPagePresets,
} from './workflow';

// One preset list per page flavor. The "general" flavor (patients list,
// unknown routes) stays empty: general drafts render no preset grid.
export const AGENT_PROMPT_LIBRARY: Record<
  AgentPromptPage,
  AgentPromptPresetList
> = {
  patient: patientPagePresets,
  report: reportPagePresets,
  'report-cbct': reportCbctPagePresets,
  'report-pano': reportPanoPagePresets,
  'report-bitewings': reportBitewingsPagePresets,
  'report-ioxray': reportIoxrayPagePresets,
  'report-endo': reportEndoPagePresets,
  'report-implant': reportImplantPagePresets,
  'report-molar': reportMolarPagePresets,
  'report-segmentation': reportSegmentationPagePresets,
  consultation: consultationPagePresets,
  photos: photosPagePresets,
  document: documentPagePresets,
  encounter: encounterPagePresets,
  templates: templatesPagePresets,
  general: { write: [], understand: [] },
};
